import { PhoneCallGenerator } from '@main/generators/phone-call.generator';
import { Constants, HangupResult } from '@salesforce/scv-connector-base';
import type { CallType } from '@main/types/sf-types';

export class IdleResultGenerator {
  static generate(
    callId: string,
    callType: CallType,
    phoneNumber: string,
  ): HangupResult {
    const phoneCall = PhoneCallGenerator.generate(
      callId,
      callType,
      phoneNumber,
    );

    phoneCall.state = Constants.CALL_STATE.ENDED;
    phoneCall.reason = Constants.HANGUP_REASON.PHONE_CALL_ERROR;
    phoneCall.closeCallOnError = true;
    phoneCall.agentStatus = 'MissedCallAgent';

    return new HangupResult({
      calls: phoneCall,
    });
  }
}
